function init() {
    var popUpButtons = document.querySelectorAll(".popUpButton button");

    if (popUpButtons.length > 0) {
        popUpButtons.forEach(popUpButton => {
            var buttonId = popUpButton.id;
            var modalId = `modal-${buttonId}`;
            var modal = document.getElementById(modalId);
            var btnCloseModal = document.querySelector(`#${modalId} .close`);
            // show modal
            popUpButton.addEventListener("click", () => {
                modal.classList.add("show");
            });
            // close modal when the close button is clicked
            btnCloseModal.addEventListener("click", () => {
                modal.classList.remove("show");
            });
            // close modal when clicking outside of it
            modal.addEventListener("click", () => {
                modal.classList.remove("show");
            });
        });
    }
}

export default { init };
